<template>
  <div class="ty-main">
    <div class="ty-tip">
      <div class="ty-img">
        <img src="../../assets/images/prompt.png" />
      </div>
      <div class="tip">
        已经开通会话存档的员工离职后，可以分配他的企业资产给其他员工
      </div>
    </div>
    <div class="ty-card" style="heigth: 80px;">
      <div class="ty-tab">
        <div
          class="tab-item"
          v-for="(item, index) in tabs"
          :key="index"
          :class="{ active: tabIndex === index }"
          @click="tabChange(index)"
          v-auth="[item.auth]"
        >
          {{ item.title }}
          <span v-if="tabIndex === index">[{{ total }}人]</span>
        </div>
      </div>
    </div>
    <div class="ty-content white" v-if="tabIndex < 2">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item label="已离职成员:">
          <el-input
            v-model="employee"
            placeholder="请选择离职成员"
            @focus="openSelectDialog"
            clearable
            @clear="reset"
            style=""
          ></el-input>
        </el-form-item>
        <!--<div class="fr">
          <el-button
            v-if="tabIndex === 0"
            type="primary"
            @click="refresh"
            :loading="refurbish"
            :disabled="isAllowRefresh"
            >{{ isAllowRefresh ? '刷新中...' : '刷新' }}</el-button
          >
          <el-button
            v-else-if="tabIndex === 1"
            type="primary"
            @click="refresh01"
            :loading="refurbish01"
            :disabled="isAllowRefresh"
            >{{ isAllowRefresh ? '刷新中...' : '刷新' }}</el-button
          >
        </div> -->
      </el-form>
      <el-table
        ref="selectionChangae"
        :data="tableData"
        style="width: 100%;"
        id="table"
        :row-key="rowKey"
        :stripe="false"
        @selection-change="selectionChangae"
      >
        <el-table-column type="selection" :reserve-selection="true" width="65"> </el-table-column>
        <el-table-column label="已离职成员" fixed width="300">
          <template slot-scope="scope">
              <el-popover
                v-if="scope.row.name && scope.row.name.length > 10"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.name}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></div>
                <span slot="reference" style="color: #303133;">{{scope.row.name | ellipsis}}<span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></span>
              </el-popover>
              <span v-else>{{scope.row.name}}
                <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                <span class="tag" v-if="scope.row.new_user_status === -1">离职</span></span>
              <span v-if="scope.row.name === null">未知员工</span>
            </template>
        </el-table-column>
        <el-table-column prop="department_name" label="所属部门" width="270">
           <template slot-scope="scope">
            <div v-if="scope.row.department_name.length > 0">
                <el-popover
                  v-if="scope.row.department_name.length > 20"
                  placement="top-start"
                  popper-class="popperBox"
                  trigger="hover">
                  <div>{{scope.row.department_name}}</div>
                  <span slot="reference" style="color: #303133;">{{scope.row.department_name | ellipsiss}}</span>
                </el-popover>
                <span v-else>{{scope.row.department_name}}</span>
              </div>
              <span v-else>-</span>
            </template>
        </el-table-column>
        <el-table-column
          min-width="200"
          v-if="tabIndex === 0"
          :label="tabIndex === 0 ? '未分配客户数' : ''"
        >
           <template slot-scope="scope">
            <div class="okm">{{scope.row.unassigned_customer_number ? scope.row.unassigned_customer_number : '-'}}</div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200"
          v-else
          :label="tabIndex === 1 ? '已分配客户数' : ''"
        >
          <template slot-scope="scope">
            <div class="okm">{{scope.row.assigned_customer_number ? scope.row.assigned_customer_number : '-'}}</div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200"
          v-if="tabIndex === 0"
          :label="tabIndex === 0 ? '未分配群聊数' : '0'"
        >
           <template slot-scope="scope">
            <div class="okm">{{scope.row.unassigned_group_number ? scope.row.unassigned_group_number : '-'}}</div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200"
          v-else
          :label="tabIndex === 1 ? '已分配群聊数' : '0'"
        >
           <template slot-scope="scope">
            <div class="okm">{{scope.row.assigned_group_number ? scope.row.assigned_group_number : '-'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="离职时间" min-width="180">
           <template slot-scope="scope">
            <div class="okm">{{scope.row.quit_time ? scope.row.quit_time : '-'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <div v-if="tabIndex === 0">
              <el-button
                type="text"
                @click="
                  $router.push({
                    path: '/inherit/detail/' + scope.row.staff_id
                  })
                "
                v-auth="['inheritOffOff']"
                >分配</el-button
              >
            <!--  <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                @click="
                  $router.push({
                    path: '/inherit/inheritedDetail/' + scope.row.staff_id
                  })
                "
                v-auth="['inheritOffOn']"
                >已分配</el-button
              >  -->
            </div>
            <el-button
              type="text"
              v-auth="['inheritView']"
              v-else
              @click="
                $router.push({
                  path: '/inherit/inheritedDetail/' + scope.row.staff_id
                })
              "
              >详情</el-button
            >
          </template>
        </el-table-column>
        <template #empty>
          <el-empty v-loading="ischange"></el-empty>
        </template>
      </el-table>

      <div class="toolbar">
        <div>
          <el-button type="primary"  v-auth="['inheritOther']" @click="openAssign" v-if="tabIndex === 0"
            >分配给其他成员</el-button
          >
        </div>
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <no-client v-else @getTotal="getTotal"></no-client>
    <el-dialog title="选择离职员工" :visible.sync="isSelectDialog" :show-close="false" :close-on-click-modal="false" width="600px">
      <el-row>
        <el-col :span="12" style="border-right: 1px solid rgba(216, 220, 225, 0.39);">
          <el-card class="box-card" :body-style="{height: '460px', overflow: 'auto' }" shadow="never">
           <!-- <div slot="header">已离职人员</div> -->
            <el-input
              class="filter-input"
              placeholder="搜索员工"
              v-model="filterText"
              prefix-icon="el-icon-search"
              size="small"
              clearable
            >
            </el-input>
            <el-tree
              ref="tree"
              :data="treeData"
              node-key="staff_id"
              :props="defaultProps"
              :show-checkbox="false"
              :check-on-click-node="true"
              @check-change="getChecked"
              :filter-node-method="filterNode"
              :default-checked-keys="peoples"
            >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span style="margin-left: -25px;">
                <img class="organization-img" src="../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                {{ node.label }} <span
                      v-if="node.checked && node.label"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
              </span>
            </span>
            </el-tree>
          </el-card>
        </el-col>
        <div class="huain"></div>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }">
            <div class="xuanze">已选择的员工</div>
            <ul class="infinite-list">
              <li class="cich" v-for="item in checkedDimission" :key="item.staff_id">
                <img class="organization-img" src="../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                <div :class="item.name.length <= 20 ? 'wqeq' : 'gfdgd'">{{ item.name }}</div>
                <div class="uiwe">
                  <i class="el-icon-close" @click="employeeClose(item)"></i>
                </div>
              </li>
            </ul>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="cc_close">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled2" @click="reLoadTable">确定</el-button>
      </span>
    </el-dialog>
    <department
      :isShow="isDepartmentDialog"
      @check-user="checkUser"
      :isMultiple="false"
      :checkeds="checkedEmployees"
    ></department>
  </div>
</template>
<script>
import Department from '../../components/department'
import NoClient from './NoClient'
// import { isAllowRefresh } from '@/utils/util'
export default {
  components: {
    Department,
    NoClient
  },
  data() {
    this.selectedList = []
    this.checkedDimission = []
    return {
      tabs: [
        {
          title: '离职未被继承成员',
          auth: 'inheritOff'
        },
        {
          title: '离职已继承成员',
          auth: 'inheritOn'
        },
        {
          title: '离职无资产',
          auth: 'inheritOffNone'
        }
      ],
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      total: 0,
      refurbish: false,
      refurbish01: false,
      disabled2: true,
      isAllowRefresh: false,
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'checkTitle'
      },
      loading: false,
      checkedDimission: [],
      employee: '',
      tabIndex: 0,
      isSelectDialog: false,
      isDepartmentDialog: false,
      filterText: '',
      ischange: false,
      type: '',
      sgi1b: false,
      gfgd: '',
      checkedEmployees: [],
      peoples: []
    }
  },
  beforeMount() {
    const authList = this.$store.state.authList
    if (authList.includes('inheritOn') && !authList.includes('inheritOff')) {
      this.tabIndex = 1
    }
  },
  mounted() {
    const getStorage = JSON.parse(localStorage.getItem('Storage'))
    if (getStorage) {
      this.total = getStorage.total
      this.tableData = getStorage.tableData
      this.treeData = getStorage.treeData
      this.tabIndex = getStorage.tabIndex
      this.employee = getStorage.employee
      this.currentPage = getStorage.currentPage
      localStorage.removeItem('Storage')
    } else {
      this.getList()
    }
    this.gfgd = sessionStorage.getItem('index')
    // alert(this.gfgd)
    // alert(this.gfgd === '0')
    if (this.gfgd === '0') {
      // alert(333355)
      this.getList()
    } else if (this.gfgd === '1') {
      // alert(666333)
      this.getList2()
    }
    if (this.gfgd === 0) {
      // alert(6666)
      this.getList()
    } else if (this.gfgd === 1) {
      // alert(666333)
      this.getList2()
    }

    this.getlistAll()
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    checkedDimission(val) {
      if (val.length > 0) {
        this.disabled2 = false
      } else {
        this.disabled2 = true
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'inheritDetail' || to.name === 'inheritedDetail') {
      const Storage = JSON.stringify(this._data)
      localStorage.setItem('Storage', Storage)
    }
    next()
  },
  methods: {
    getTotal(res) {
      this.ischange = true
      this.total = res
    },
    // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.checkTitle.indexOf(value) !== -1
    },
    // 离职未被继承列表
    getList(employeeId) {
      this.ischange = true
      const params = {
        page: this.currentPage
      }
      if (employeeId) {
        params.user_id = employeeId
      }
      this.$api.get('/api/v1/inherit/index', params).then(
        response => {
          this.total = response.total || 0
          this.tableData = response.list
          this.ischange = false
        },
        () => {
          this.ischange = false
        }
      )
    },
    // 获取已继承列表
    getList2(employeeId) {
      this.ischange = true
      const params = {
        page: this.currentPage
      }
      if (employeeId) {
        params.user_id = employeeId
      }
      this.$api.get('/api/v1/inherit/be-succeeded', params).then( res => {
        this.total = res.total || 0
        this.tableData = res.list
        this.ischange = false
      })
    },
    // 无资产列表
    getList3(employeeId) {
      this.loading = true
      this.$api
        .get('/api/v1/inherit/no-assets', {
          page: this.currentPage,
          user_id: employeeId
        })
        .then(res => {
          this.total = res.total
          this.$emit('getTotal', res.total)
          this.tableData = res.list
          this.loading = false
        })
    },
    // 获取离职部门员工
    getlistAll() {
      this.loading = true
      const params = {
        type: this.tabIndex + 1,
        page: 1,
        limit: 9999
      }
      this.$api.get('/api/v1/inherit/quit-department-staff', params).then(response => {
        let res = response
        if (response && typeof response === 'string') {
          res = JSON.parse(response)
        }
        const treeData = res || []
        treeData.forEach(v => {
          if (v.name === null) {
             v.checkTitle = '未知员工'
          } else {
             v.checkTitle = `${v.name} - ${v.department_name}`
          }
        })
        this.treeData = treeData || []
        this.loading = false
      })
    },
    getChecked(value, isCheck) {
      const checkedDimission = this.checkedDimission
      if (isCheck) {
         checkedDimission.push({
          staff_id: value.staff_id,
          name: value.name
        })
        this.sgi1b = true
      } else {
        checkedDimission.forEach((item, i) => {
          if (item.staff_id === value.staff_id) {
            checkedDimission.splice(i, 1)
            this.sgi1b = false
          }
        })
      }
      this.checkedDimission = checkedDimission
      this.checkedDimission.forEach(k => {
        this.peoples.push(k.staff_id)
      })
    },
    // employeeClose(value) {
    //   this.$refs.tree.setChecked(value.id, false)
    // },
    employeeClose(value) {
      this.checkedDimission.some((item, i) => {
        if (item.staff_id === value.staff_id) {
          this.checkedDimission.splice(i, 1)
          this.$refs.tree.setChecked(value.staff_id, false)
        }
      })
    },
    reLoadTable() {
      const employee = []
      const employeeId = []
      this.checkedDimission.forEach(v => {
        employee.push(v.name)
        employeeId.push(v.staff_id)
      })
      this.employee = employee.join('，')
      this.currentPage = 1
      if (this.tabIndex === 0) {
         this.getList(employeeId)
      } else if (this.tabIndex === 1) {
         this.getList2(employeeId)
      }

      this.isSelectDialog = false
      this.$refs.selectionChangae.clearSelection()
    },
    // 选择员工分配
    checkUser(checkedEmployee) {
      if (checkedEmployee === '') {
        this.isDepartmentDialog = false
        return false
      }
      if (checkedEmployee && checkedEmployee.length) {
        this.$confirm(`是否将资产分配给${checkedEmployee[0].name}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
          closeOnClickModal: false
        })
          .then(() => {
            const params = {
              quit_user_id: this.selectedList,
              user_id: checkedEmployee[0].id
            }
            this.$api
              .post('/api/v1/inherit/assign-customer-list', params)
              .then(() => {
                this.$message({
                  message: '分配成功！',
                  type: 'success'
                })
                this.getList()
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消分配'
            })
          })

        this.isDepartmentDialog = false
      } else {
        this.isDepartmentDialog = false
      }
    },
    refresh() {
      this.refurbish = true
      this.ischange = true
      if (this.tabIndex === 0) {
        this.type = 1
        const params = {
        type: this.type
        }
        this.$api
          .post('/api/v1/inherit/refresh-transfer', params)
          .then(res => {})
          this.renovate()
        }
    },
    refresh01() {
      this.refurbish01 = true
      this.ischange = true
      if (this.tabIndex === 1) {
        this.type = 2
        const params = {
        type: this.type
        }
        this.$api
          .post('/api/v1/inherit/refresh-transfer', params)
          .then(res => {})
          this.renovate()
        }
    },
    cc_close() {
      this.isSelectDialog = false
      this.filterText = ''
    },
    renovate() {
      if (this.tabIndex === 0) {
        this.type = 1
      } else if (this.tabIndex === 1) {
        this.type = 2
      }
      const params = {
        type: this.type
      }
      this.$api
        .get('/api/v1/get/refresh/status', params)
        .then(() => {
          this.$message.success('刷新成功')
          this.refurbish = false
          this.refurbish01 = false
          this.isAllowRefresh = false
          this.ischange = false
        })
    },
    currentChange(val) {
      this.currentPage = val
      if (this.tabIndex === 0) {
        this.getList()
      } else {
        this.getList2()
      }
    },
    // 选择要分配的离职员工
    selectionChangae(selection) {
      const arr = []
      selection.forEach(v => {
        arr.push(v.staff_id)
      })
      const result = Array.from(new Set(arr))
      this.selectedList = arr
    },
    rowKey(row) {
      return row.staff_id
    },
    reset() {
      this.currentPage = 1
      this.employee = ''
      if (this.tabIndex === 0) {
        this.ischange = true
        //  return false
        sessionStorage.setItem('index', this.tabIndex)
        this.getList()
      } else if (this.tabIndex === 1) {
        this.ischange = true
        sessionStorage.setItem('index', this.tabIndex)
        this.getList2()
      } else {
        this.ischange = true
        sessionStorage.setItem('index', this.tabIndex)
        this.getList3()
      }
    },
    openAssign() {
      if (this.selectedList.length > 0) {
        this.isDepartmentDialog = true
      } else {
        this.$message('请选择离职成员！')
      }
    },
    tabChange(index) {
      console.log(index)
      this.tabIndex = index
      this.currentPage = 1
      this.filterText = ''
      this.checkedDimission = []
      this.getlistAll()
      if (this.tabIndex === 0) {
        this.ischange = true
        //  return false
        sessionStorage.setItem('index', this.tabIndex)
        this.getList()
      } else if (this.tabIndex === 1) {
        this.ischange = true
        sessionStorage.setItem('index', this.tabIndex)
        this.getList2()
      } else if (this.tabIndex === 2) {
        this.ischange = true
        sessionStorage.setItem('index', this.tabIndex)
        this.getList3()
      }
      // if (this.ischange) {
      //   this.ischange = false
      // } else {
      //   return false
      // }
      Object.assign(this, {
        tableData: [],
        total: 0,
        tabIndex: index,
        employee: '',
        currentPage: 1
      })
      // if (index < 2) {
      //   this.getList()
      //   this.getList2()
      // }
    },
    openSelectDialog() {
      // this.treeData = []
      // this.checkedDimission = []
      // this.getlistAll()
      this.isSelectDialog = true
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .ty-card {
  padding: 24px 32px;
  // line-height: 70px;
  padding-bottom: 5px;
  border-radius: 2px;
}
::v-deep .el-card {
  position: relative;
  box-shadow: none;
}
.el-tag {
  margin: 0 10px 10px 0;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
 .ty-tab .tab-item.active{
  font-size: 18px;
  font-weight: 550;
}
::v-deep .ty-tab .tab-item {
  height: 29px;
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 0;
  border-radius: 2px 2px 0px 0px;
}
::v-deep .el-tag{
  width: auto;
  color: #204A9EFF;
  background-color:#fff;
  border-color: #204A9EFF;
}
::v-deep .el-tag .el-icon-close::before{
  display: none;
}
::v-deep .el-dialog .el-dialog__footer{
  text-align:right;
}
::v-deep .el-button--primary{
  letter-spacing: 0;
}
.el-button--primary.is-disabled{
  opacity: 0.7;
}
::v-deep .el-dialog__body{
  padding: 0;
  overflow: inherit;
}
::v-deep .el-card__body{
  box-shadow: none;
}
::v-deep .ty-tab .tab-item.active::after{
    content: "";
    position: absolute;
    top: 54px;
    left: 0;
    width: 100%;
    height: 3px;
    background: #204a9e;
    border-radius: 2px 2px 0px 0px;
}
::v-deep .ty-tab .tab-item:hover{
  color: #204A9E;
}
</style>
